import { Tooltip } from "@msuite/ui/tooltip";
import { cn } from "@msuite/ui/utils";
import { Holidays } from "@msuite/utils/holidays";
import { memo } from "react";
import type { AbsencesCalendarCell } from "./use-absences-calendar";

/** Props Interface */
interface AbsencesCalendarHeaderMonthItemProps {
	cell: AbsencesCalendarCell;
}

function AbsencesCalendarHeaderMonthItemImpl({ cell }: AbsencesCalendarHeaderMonthItemProps) {
	const { cellMoment, isInRange, isWeekend, isHoliday, isToday } = cell;

	/** Guard */
	if (!isInRange) return <div className="w-full h-full bg-gray-50 dark:bg-zinc-900/50" />;

	/** Render */
	return (
		<div
			className={cn(
				"v-stack w-full h-full flex-center gap-0 items-center *:text-xs",
				isWeekend && "bg-gray-100 dark:bg-zinc-800",
				isHoliday && "stripes",
			)}
		>
			<Tooltip
				label={Holidays.getHolidayByDate(cell.cellMoment.db(), "BE")?.translate("de")}
				isDisabled={!isHoliday}
				className="flex-center flex-col w-full h-full cursor-pointer"
			>
				<p className={cn(isHoliday && "text-red-500!")}>{cellMoment.format("dd").charAt(0)}</p>
				<p
					className={cn(
						"size-5 rounded-full flex items-center justify-center",
						isHoliday && "text-red-500!",
						isToday && "bg-accent-500! text-white!",
					)}
				>
					{cellMoment.format("DD")}
				</p>
			</Tooltip>
		</div>
	);
}

export const AbsencesCalendarHeaderMonthItem = memo(AbsencesCalendarHeaderMonthItemImpl);
